module.exports = __webpack_public_path__ + "static/img/h4-4.122dabc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h4-4.png
// module id = ZQ2E
// module chunks = 1